import React from 'react';
import DOMPurify from 'dompurify';

type SafeHtmlRendererProps = React.HTMLAttributes<HTMLDivElement> & {
  html: string;
  forceBody?: boolean;
};

export const SafeHtmlRenderer = React.forwardRef<
  HTMLDivElement,
  SafeHtmlRendererProps
>(({ html, forceBody, ...divProps }, ref) => {
  const sanitizedHtml = DOMPurify.sanitize(html, {
    FORCE_BODY: forceBody,
  });

  return (
    <div
      {...divProps}
      ref={ref}
      // We just sanitized it and didn't pass it anywhere else, so it's safe to render.
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
});
